<script>
import moment from 'moment'

export default {
  data() {
    return {

      series: null,
      chartOptions: {
        chart: {
          type: "area",
          height: 240,
          toolbar: "false",
        },
        stroke: {
          curve: "smooth",
          width: 2,
        },
        colors: ["#f1b44c"],

        dataLabels: {
          enabled: false,
        },
        markers: {
          size: 0,
          style: "hollow",
        },
        xaxis: {
          type: "datetime",
          min: new Date("01 Jan 2023").getTime(),
          tickAmount: 6,
        },
        tooltip: {
          x: {
            format: "dd MMM yyyy",
          },
        },
        fill: {
          type: "gradient",
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.9,
            stops: [0, 100],
          },
        },
      },
      selection: "one_year",
    };
  },
  mounted() {
    // console.log('mounted_overview')


    let dataAgora = moment()
    let dataFinal = []
    let cont = 0
    while(cont < 370){
      dataAgora = dataAgora.subtract(1, 'days')
      // console.log(dataAgora.valueOf())
      let randomnumber = Math.floor(Math.random() * (100 - 4 + 1)) + 4;
      // console.log(randomnumber)
      dataFinal.push([
        dataAgora.valueOf(), randomnumber
      ])
      cont++
    }


    this.series = [
      {
        data: dataFinal
      }
    ]

  },
  methods: {
    updateData: function(timeline) {
      console.log(new Date("28 Jan 2023").getTime())
      let dataAtual = moment()

      let inicioMes = dataAtual.startOf('month').valueOf()
      let finalMes = dataAtual.endOf('month').valueOf()

      let inicioSemestre = dataAtual.subtract(6, 'month').valueOf()
      let inicioAno = dataAtual.subtract(12, 'month').valueOf()

      console.log('inicioSemestre')
      console.log(inicioSemestre)

      this.selection = timeline;
      switch (timeline) {
        case "one_month":
          this.$refs.chart.zoomX(
              inicioMes,
              finalMes
          );
          break;
        case "six_months":
          this.$refs.chart.zoomX(
              inicioSemestre,
              finalMes
          );
          break;
        case "one_year":
          this.$refs.chart.zoomX(
              inicioAno,
              finalMes
          );
          break;
        case "all":
          this.$refs.chart.zoomX(
              inicioAno,
              finalMes
          );
          break;
        default:
      }
    },
  },
};
</script>

<template>
  <div class="card">
    <div class="card-body">
      <h4 class="card-title mb-3">Overview</h4>

      <div id="chart" dir="ltr">
        <div class="toolbar button-items text-center">
          <button
            id="one_month"
            class="btn btn-light btn-sm"
            @click="updateData('one_month')"
            :class="{ active: selection === 'one_month' }"
          >
            1M
          </button>

          <button
            id="six_months"
            class="btn btn-light btn-sm"
            @click="updateData('six_months')"
            :class="{ active: selection === 'six_months' }"
          >
            6M
          </button>

          <button
            id="one_year"
            class="btn btn-light btn-sm"
            @click="updateData('one_year')"
            :class="{ active: selection === 'one_year' }"
          >
            12M
          </button>

          <button
            id="all"
            class="btn btn-light btn-sm"
            @click="updateData('all')"
            :class="{ active: selection === 'all' }"
          >
            Todos
          </button>
        </div>
        <apexchart
            v-if="series"
          type="area"
          height="240"
          ref="chart"
          :options="chartOptions"
          :series="series"
        ></apexchart>
      </div>
    </div>
  </div>
</template>
